import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import AddConnection from '@/views/AddConnection';
import SignIn from '@/views/SignIn.vue';
import store from '@/store';

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/sign-in',
            name: 'SignIn',
            component: SignIn
        },
        {
            path: '/add',
            name: 'AddConnection',
            component: AddConnection,
            beforeEnter: (to, from, next) => {
                const {mode} = to.query;
                store.commit('setMode', mode);
                next();
            }
        }
    ]
});

